// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__48CsU","bigColWidth":"Table_bigColWidth__1_bw5","biggerColWidth":"Table_biggerColWidth__3ohCr","row":"Table_row__3zSIu","col":"Table_col__2RBmA"};